import { DEFAULT_LANG, getStoredLang } from './langs';
import ru from './ru';
import uzCyrl from './uzCyrl';
import uzLatn from './uzLatn';

export const resources = {
    ru: { translation: ru },
    'uz-Latn': { translation: uzLatn },
    'uz-Cyrl': { translation: uzCyrl },
};

export { DEFAULT_LANG, getStoredLang };
